/*
 * Shared hero behavior (hero section + homepage hero gallery).
 *
 * The hero title's size is plain CSS (gbg-hero.css), so nothing here touches it. This file only
 * demotes the theme's own page-title <h1>s so the hero title is the page's H1.
 */
(function () {
  'use strict';
  if (window.__gbgHeroInit) return;

  window.__gbgHeroInit = true;

  document.querySelectorAll('h1.collection-hero__title, h1.main-page-title').forEach(function (el) {
    var p = document.createElement('p');
    p.className = 'gbg-hero-suppressed-title';
    p.innerHTML = el.innerHTML;
    el.replaceWith(p);
  });
})();
